var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29 10.232a2.387 2.387 0 0 0 -.318-1.244 2.451 2.451 0 0 0 -.936-.879q-5.194-2.868-10.393-5.733a2.642 2.642 0 0 0 -2.763.024c-1.378.779-8.275 4.565-10.331 5.706a2.287 2.287 0 0 0 -1.259 2.125v11.539a2.4 2.4 0 0 0 .3 1.22 2.434 2.434 0 0 0 .954.9c2.056 1.141 8.954 4.927 10.332 5.706a2.642 2.642 0 0 0 2.763.026q5.19-2.871 10.386-5.733a2.444 2.444 0 0 0 .955-.9 2.4 2.4 0 0 0 .3-1.22v-11.537",
    fill: "#659ad2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.549 23.171a2.126 2.126 0 0 0 .147-.182 2.4 2.4 0 0 0 .3-1.22v-11.537a2.387 2.387 0 0 0 -.318-1.244c-.036-.059-.089-.105-.13-.16l-12.548 7.172z",
    fill: "#00599c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m28.549 23.171-12.549-7.171-12.549 7.171a2.435 2.435 0 0 0 .809.72c2.056 1.141 8.954 4.927 10.332 5.706a2.642 2.642 0 0 0 2.763.026q5.19-2.871 10.386-5.733a2.43 2.43 0 0 0 .808-.719z",
    fill: "#004482"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.6 18.02a4.121 4.121 0 1 1 -.027-4.087l3.615-2.073a8.309 8.309 0 0 0 -15.488 4.14 8.216 8.216 0 0 0 1.1 4.117 8.319 8.319 0 0 0 14.411-.017z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.076 15.538h-.926v-.921h-.925v.921h-.926v.923h.926v.92h.925v-.92h.926z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.549 15.538h-.926v-.921h-.926v.921h-.926v.923h.926v.92h.926v-.92h.926z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpp);
export default __webpack_public_path__ + "static/media/cpp.31960b6d525cc10262287d546b008a2e.svg";
export { ForwardRef as ReactComponent };